import React, { useEffect, useState } from 'react'
import { Grid, Container, useMediaQuery, Breadcrumbs } from '@material-ui/core'
import { ButtonAddHLPure, SearchBarHLPure, SimpleLoading, GridSelectionHLPure, DropDownBtnHLPure } from '../../pures'
import { useTranslation } from 'react-i18next'
import { NIL as NIL_UUID } from 'uuid'
import { ArrowBtnMobile } from '../../../assets/logos/icons'
import DigitalVaultCategoriesAdministrationConfigurationsView from './digital-vault-categories-administration-configurations.view'
import './digital-vault-categories-administration.css'
import { NIL } from 'uuid'

const DigitalVaultCategoriesAdministrationView = (props) => {
    const { t } = useTranslation()
    const {
        defaultCategories,
        updateCategories,
        loadingRequesting,
        toggleLoadingRequesting,
        completedRequesting,
        toggleCompletedRequesting,
        errorRequesting,
        toggleErrorRequesting,
        setMessage,
        getSubCategories,
        updateSubcategories,
        showWarningRequesting,
        toggleWarningRequesting
    } = props

    const [searchValue, setSearchValue] = useState('')
    const [categories, setCategories] = useState([])
    const [selectedUser, setSelectedUser] = useState({});
    const [selectedSubcategory, setSelectedSubcategory] = useState({})
    const [selectedValueFilter, setSelectedValue] = useState('')
    const [showDetails, setShowDetails] = useState(false);
    const isMobile = useMediaQuery('(max-width:820px)')
    const [showSubcategories, setShowSubcategories] = useState(false)
    const [searchValueSubcat, setSearchValueSubcat] = useState('')
    const [routes, setRoutes] = useState([])
    const [subcategories, setSubcategories] = useState([])
    const [defaultValue, setDefaultValue] = useState({})
    const mobile = useMediaQuery('(max-width:560px)')

    const [nameComponentUser, setNameComponentUser] = useState('');

    const firstColumnGrid = (props2) => {
        return (
            <td className='digitalVaultCategoriesAdministration-cell-one-item-1'>
                <div className={'gridHLPure-containerAvatar'}>
                    <div className='gridHLPure-imageAvatar'>
                        <img
                            alt='profile-img'
                            src={props2.dataItem.icon ? `${process.env.REACT_APP_AWS_S3_BUCKET_URL_ICONS}${props2.dataItem.icon}` : 'https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/DefaultCategory.svg'}
                            className='gridHLPure-avatar'
                        />
                    </div>
                    <div className={'gridHLPure-containerLabel'}>
                        <span className='gridHLPure-userName'
                            onClick={mobile && selectedValueFilter === (props2.dataItem.companyId ? props2.dataItem.companyId : NIL) ? async () => {
                                setSelectedUser(props2.dataItem)
                                await getSubCategories(props2.dataItem.companyId, props2.dataItem.categoryId)
                                const rutas = [...routes]
                                rutas[rutas.length - 1] = {
                                    ...rutas[rutas.length - 1],
                                    name: props.categories.find(cat => cat.company.id === selectedValueFilter).company.companyName,
                                    callback: () => {
                                        setShowDetails(false)
                                        setNameComponentUser('')
                                        setShowSubcategories(false)
                                        setRoutes([routes[0]])
                                    }
                                }

                                rutas.push({
                                    name: props2.dataItem.name, callback: () => { }
                                })
                                setRoutes(rutas)
                                setShowSubcategories(true)
                            }
                                :
                                null
                            }
                        >
                            {props2.dataItem.name}
                        </span>
                    </div>
                </div>
            </td >
        );
    }

    const firstColumnSubcategoriesGrid = (props2) => {
        return (
            <td className='digitalVaultCategoriesAdministration-cell-one-item-1'>
                <div className={'gridHLPure-containerAvatar'}>
                    {/* <div className='gridHLPure-imageAvatar'>
                        <img
                            alt='profile-img'
                            src={props2.dataItem.icon ?? 'https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/DefaultCategory.svg'}
                            className='gridHLPure-avatar'
                        />
                    </div> */}
                    <div className={'gridHLPure-containerLabel'}>
                        <span className='gridHLPure-userName'
                            onClick={mobile && !(routes.length === 18) ? async () => {
                                setSelectedUser(props2.dataItem)
                                await getSubCategories(props2.dataItem.companyId, props2.dataItem.id)
                                const rutas = [...routes]
                                rutas[rutas.length - 1] = {
                                    ...rutas[rutas.length - 1],
                                    callback: async () => {
                                        const routesCopy = [...routes]
                                        setRoutes(routesCopy)
                                        await getSubCategories(props2.dataItem.companyId, props2.dataItem.parent)
                                    }
                                }

                                rutas.push({
                                    name: props2.dataItem.name, callback: () => { }
                                })
                                setRoutes(rutas)
                                setShowSubcategories(true)
                            }
                                :
                                null
                            }
                        >
                            {props2.dataItem.name}
                        </span>
                    </div>
                </div>
            </td >
        );
    }

    const secondColumnGrid = (props) => {
        return (
            <td className='digitalVaultCategoriesAdministration-cell-one-item-2'>
                <div>
                    <p>
                        {props.dataItem.defined}
                    </p>
                </div>
            </td>
        );
    }

    const thirdColumnGrid = (props2) => {
        return (
            <td className='digitalVaultCategoriesAdministration-cell-one-item-3'
                style={{ display: 'flex', alignItems: 'center' }}>
                {!mobile ?
                    <>
                        {selectedValueFilter === (props2.dataItem.companyId ? props2.dataItem.companyId : NIL) &&
                            <>
                                <div className={'cellActions-containerBtnsDetails'}>
                                    <button
                                        className='cellActions-btn'
                                        onClick={async () => {
                                            setSelectedUser(props2.dataItem)
                                            await getSubCategories(props2.dataItem.companyId, props2.dataItem.categoryId)
                                            const rutas = [...routes]
                                            rutas[rutas.length - 1] = {
                                                ...rutas[rutas.length - 1],
                                                name: props.categories.find(cat => cat.company.id === selectedValueFilter).company.companyName,
                                                callback: () => {
                                                    setShowDetails(false)
                                                    setNameComponentUser('')
                                                    setShowSubcategories(false)
                                                    setRoutes([routes[0]])
                                                }
                                            }

                                            rutas.push({
                                                name: props2.dataItem.name, callback: () => { }
                                            })
                                            setRoutes(rutas)
                                            setShowSubcategories(true)
                                        }}
                                    >
                                        <p className='cellActions-textBotton'>{t('digitalVaultCategoriesAdministration.main.title.subcategories')}</p>
                                    </button>
                                </div>
                                <div className={'cellActions-containerBtnsDetails'}>
                                    <button
                                        className='cellActions-btn'
                                        onClick={() => {
                                            setSelectedUser(props2.dataItem)
                                            setSearchValue('')
                                            setNameComponentUser(t('digitalVaultCategoriesAdministration.main.title.seeDetails'))
                                            setShowDetails(true)
                                        }}
                                    >
                                        <p className='cellActions-textBotton'>{t('digitalVaultCategoriesAdministration.main.title.seeDetails')}</p>
                                    </button>
                                </div>
                            </>
                        }
                    </>
                    : selectedValueFilter === (props2.dataItem.companyId ? props2.dataItem.companyId : NIL) &&
                    <div
                        className='cellActions-mobileExpanded'
                    >
                        <img
                            className='cellActions-icon-arrow'
                            alt={'cellActions-arrow'}
                            src={ArrowBtnMobile}
                            onClick={() => {
                                setSelectedUser(props2.dataItem)
                                setNameComponentUser(t('digitalVaultCategoriesAdministration.main.title.seeDetails'))
                                setShowDetails(true)
                            }}
                        />
                    </div>
                }
            </td>
        );
    }

    const thirdColumnGridSubcat = (props2) => {
        return (
            <td className='digitalVaultCategoriesAdministration-cell-one-item-3'
                style={{ display: 'flex', alignItems: 'center' }}>
                {/* {props?.dataItem?.subCategories?.length > 0 && */}
                {!mobile ?
                    <>
                        {!(routes.length === 18) &&
                            <div className={'cellActions-containerBtnsDetails'}>
                                <button
                                    className='cellActions-btn'
                                    onClick={async () => {
                                        setSelectedUser(props2.dataItem)
                                        await getSubCategories(props2.dataItem.companyId, props2.dataItem.id)
                                        const rutas = [...routes]
                                        rutas[rutas.length - 1] = {
                                            ...rutas[rutas.length - 1],
                                            callback: async () => {
                                                const routesCopy = [...routes]
                                                setRoutes(routesCopy)
                                                await getSubCategories(props2.dataItem.companyId, props2.dataItem.parent)
                                            }
                                        }

                                        rutas.push({
                                            name: props2.dataItem.name, callback: () => { }
                                        })
                                        setRoutes(rutas)
                                        setShowSubcategories(true)
                                    }}
                                >
                                    <p className='cellActions-textBotton'>{t('digitalVaultCategoriesAdministration.main.title.subcategories')}</p>
                                </button>
                            </div>
                        }
                        <div className={'cellActions-containerBtnsDetails'}>
                            <button
                                className='cellActions-btn'
                                onClick={() => {
                                    setSearchValueSubcat('')
                                    setSelectedSubcategory(props2.dataItem)
                                    setNameComponentUser(t('digitalVaultCategoriesAdministration.main.title.seeDetailsSubcategory'))
                                    setShowDetails(true)
                                }}
                            >
                                <p className='cellActions-textBotton'>{t('digitalVaultCategoriesAdministration.main.title.seeDetails')}</p>
                            </button>
                        </div>
                    </>
                    :
                    <div
                        className='cellActions-mobileExpanded'

                    >
                        <img
                            className='cellActions-icon-arrow'
                            alt={'cellActions-arrow'}
                            src={ArrowBtnMobile}
                            onClick={() => {
                                setSelectedSubcategory(props2.dataItem)
                                setNameComponentUser('Ver detalles subcategoría')
                                setShowDetails(true)
                            }}
                        />
                    </div>
                }

            </td>
        );
    }

    useEffect(() => {
        let dataUpdateSearch
        let usersCopy = [...props.categories];

        if (usersCopy.length > 0) {
            let categoriesIndex = usersCopy.findIndex((category) => category.company.id === selectedValueFilter);

            let dataUpdateFilter = [...usersCopy[categoriesIndex].categories]

            dataUpdateSearch = dataUpdateFilter.filter((client) => {
                return (
                    client.name.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0
                );
            });
            setCategories(dataUpdateSearch);
        }
    }, [searchValue])

    useEffect(() => {
        let dataUpdateSearch
        let usersCopy = [...props.subCategories];
        dataUpdateSearch = usersCopy.filter((item) => {
            return (
                item.name.toLowerCase().indexOf(searchValueSubcat.toLowerCase()) >= 0
            );
        });
        setSubcategories(dataUpdateSearch)
    }, [searchValueSubcat])

    useEffect(() => {
        let usersCopy = [...props.categories];
        if (usersCopy.length > 0) {
            let categoriesIndex = usersCopy.findIndex((category) => category.company.id === selectedValueFilter);
            setDefaultValue(usersCopy.find(category => category.company.id === selectedValueFilter).company.id)
            setCategories([...props?.categories[categoriesIndex]?.categories])
        }
    }, [selectedValueFilter])



    useEffect(() => {
        if (props?.categoriesFiltered?.length > 0 && !selectedValueFilter) {
            setCategories(props.categoriesFiltered)
            setSelectedValue(props.categories.find(cat => cat.company.id === NIL_UUID).company.id)
            setRoutes(
                [
                    {
                        name: '',
                        callback: () => {
                            setShowDetails(false)
                            setNameComponentUser('')
                            setShowSubcategories(false)
                        }
                    }
                ]
            )
        } else if (props?.categoriesFiltered?.length > 0 && selectedValueFilter) {
            setCategories(props.categories.find(cat => cat.company.id === selectedValueFilter).categories)
            setRoutes(
                [
                    {
                        name: '',
                        callback: () => {
                            setShowDetails(false)
                            setNameComponentUser('')
                            setShowSubcategories(false)
                        }
                    }
                ]
            )
            setDefaultValue(selectedValueFilter)
        } else if (props?.categoriesFiltered?.length === 0) {
            setSelectedValue(NIL)
            setRoutes(
                [
                    {
                        name: '',
                        callback: () => {
                            setShowDetails(false)
                            setNameComponentUser('')
                            setShowSubcategories(false)
                        }
                    }
                ]
            )
        }
    }, [props.categoriesFiltered])

    useEffect(() => {
        setSubcategories(props.subCategories)
    }, [props.subCategories])

    if (props.isLoading) return <SimpleLoading />

    return (
        <Container
            disableGutters
            className='digitalVaultCategoriesAdministration-container'
        >
            <Grid
                container
                spacing={3}
                className='digitalVaultCategoriesAdministration-body'
            >
                {showDetails && nameComponentUser ?
                    <DigitalVaultCategoriesAdministrationConfigurationsView
                        showWarningRequesting={showWarningRequesting}
                        selectedSubcategory={selectedSubcategory}
                        toggleWarningRequesting={toggleWarningRequesting}
                        updateSubcategories={updateSubcategories}
                        routes={routes.length}
                        defaultCategories={defaultCategories}
                        setCategories={setCategories}
                        setMessage={setMessage}
                        categories={props.categories}
                        selectedValueFilter={selectedValueFilter}
                        setSelectedValue={setSelectedValue}
                        showLoadingRequesting={loadingRequesting}
                        toggleLoadingRequesting={toggleLoadingRequesting}
                        showCompletedRequesting={completedRequesting}
                        toggleCompletedRequesting={toggleCompletedRequesting}
                        showErrorRequesting={errorRequesting}
                        toggleErrorRequesting={toggleErrorRequesting}
                        nameComponentUser={nameComponentUser}
                        updateCategories={updateCategories}
                        selectedUser={selectedUser}
                        setShowDetails={setShowDetails}
                    />
                    :
                    <>
                        {/*Container primera seccion de items, fila*/}
                        {showSubcategories ?
                            <>
                                <Grid item xs={12}>
                                    <Breadcrumbs aria-label='Categorías'>
                                        {
                                            routes.map(i =>
                                                <span
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={i.callback}
                                                >{i.name}
                                                </span>)
                                        }
                                    </Breadcrumbs>
                                </Grid>
                                <Grid
                                    item
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className='digitalVaultCategoriesAdministration-navbar'
                                >

                                    {/*Cada componente puro, estara envuelto en un grid item */}
                                    <Grid
                                        item
                                        lg={4}
                                        md={4}
                                        xs={12}
                                        sm={12}
                                        className='digitalVaultCategoriesAdministration-buttonHLPure'
                                    >
                                        <ButtonAddHLPure
                                            nameBtn={t('digitalVaultCategoriesAdministration.subcategories.addCategory')}
                                            iconAdd
                                            onClickBtn={() => {
                                                setShowDetails(true)
                                                setNameComponentUser(t('digitalVaultCategoriesAdministration.subcategories.addCategory'))
                                            }}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        lg={5}
                                        md={4}
                                        xs={12}
                                        sm={12}
                                        className='digitalVaultCategoriesAdministration-searchHLPure'
                                    >
                                        <SearchBarHLPure
                                            placeholder={t('digitalVaultCategoriesAdministration.subcategories.searchCategories')}
                                            onSearchChange={(e) => setSearchValueSubcat(e.target.value)}
                                            searchValue={searchValueSubcat}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid
                                    item
                                    className='digitalVaultCategoriesAdministration-gridContainer'
                                >
                                    <GridSelectionHLPure
                                        {...props}
                                        //Data del grid
                                        dataGrid={subcategories}
                                        skip={0}
                                        take={6}
                                        //Columna uno
                                        titleRow1={t('digitalVaultCategoriesAdministration.subcategories.grid.titleHeader1')}
                                        cellColumnOne={firstColumnSubcategoriesGrid}
                                        //Columna dos
                                        columnTwo={!isMobile}
                                        titleRow2={t('digitalVaultCategoriesAdministration.subcategories.grid.titleHeader2')}
                                        cellColumnTwo={secondColumnGrid}
                                        //Columna 3
                                        columnThree
                                        titleRow3={!mobile ? t('digitalVaultCategoriesAdministration.subcategories.grid.titleHeader3') : ''}
                                        cellColumnThree={thirdColumnGridSubcat}
                                        selectedValueFilter={selectedValueFilter}
                                        onFilterChange={setSelectedValue}
                                        onSelectedItem={setSelectedSubcategory}
                                        setNameComponentUser={setNameComponentUser}
                                        filter={true}
                                        setShowDetails={setShowDetails}
                                        widthHeader={'gridHLPure-digitalVaultCategoriesAdministration-col1Header'}
                                        styleCol1={'gridHLPure-digitalVaultCategoriesAdministration-cellItemStylesCol1'}
                                        styleCol3={'gridHLPure-digitalVaultCategoriesAdministration-cellItemStylesCol3'}
                                        styleCol4={'gridHLPure-digitalVaultCategoriesAdministration-cellItemStylesCol4'}
                                        widthHeaderCol4={'gridHLPure-digitalVaultCategoriesAdministration-cellItemStylesTh4'}
                                        headerColumnOneClass={'digitalVaultCategoriesAdministration-headerCol1'}
                                        headerColumnTwoClass={'digitalVaultCategoriesAdministration-headerCol2'}
                                        headerColumnFiveClass={'digitalVaultCategoriesAdministration-headerCol5'}
                                    />
                                </Grid>
                            </> :
                            <>
                                <Grid
                                    item
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className='digitalVaultCategoriesAdministration-navbar'
                                >
                                    {/*Cada componente puro, estara envuelto en un grid item */}
                                    <Grid
                                        item
                                        lg={4}
                                        md={4}
                                        xs={12}
                                        sm={12}
                                        className='digitalVaultCategoriesAdministration-buttonHLPure'
                                    >
                                        <ButtonAddHLPure
                                            nameBtn={t('digitalVaultCategoriesAdministration.main.addCategory')}
                                            iconAdd
                                            onClickBtn={() => {
                                                setShowDetails(true)
                                                setNameComponentUser(t('digitalVaultCategoriesAdministration.main.addCategory'))
                                            }}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        lg={5}
                                        md={4}
                                        xs={12}
                                        sm={12}
                                        className='digitalVaultCategoriesAdministration-searchHLPure'
                                    >
                                        <SearchBarHLPure
                                            placeholder={t('digitalVaultCategoriesAdministration.main.searchCategories')}
                                            onSearchChange={(e) => setSearchValue(e.target.value)}
                                            searchValue={searchValue}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        lg={3}
                                        md={4}
                                        xs={12}
                                        sm={12}
                                        className='digitalVaultCategoriesAdministration-filterHLPure '
                                    >
                                        <DropDownBtnHLPure
                                            labelDropdown='Filtrar por'
                                            optionsDropDown={props.filterOptions}
                                            nameOption='name'
                                            valueItem='companyId'
                                            optionsValue={defaultValue}
                                            onDropDownChange={(e) => setSelectedValue(e.target.value)}
                                            iconFilter={true}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid
                                    item
                                    className='digitalVaultCategoriesAdministration-gridContainer'
                                >
                                    <GridSelectionHLPure
                                        {...props}
                                        //Data del grid
                                        dataGrid={categories}
                                        skip={0}
                                        take={6}
                                        //Columna uno
                                        titleRow1={t('digitalVaultCategoriesAdministration.main.grid.titleHeader1')}
                                        cellColumnOne={firstColumnGrid}
                                        //Columna dos
                                        columnTwo={!isMobile}
                                        titleRow2={t('digitalVaultCategoriesAdministration.main.grid.titleHeader2')}
                                        cellColumnTwo={secondColumnGrid}
                                        //Columna 3
                                        columnThree
                                        titleRow3={!mobile ? t('digitalVaultCategoriesAdministration.main.grid.titleHeader3') : ''}
                                        cellColumnThree={thirdColumnGrid}
                                        //Columna 5
                                        // columnFive
                                        // titleRow5={'Acciones'}
                                        selectedValueFilter={selectedValueFilter}
                                        onFilterChange={setSelectedValue}
                                        onSelectedItem={setSelectedUser}
                                        setNameComponentUser={setNameComponentUser}
                                        filter={true}
                                        setShowDetails={setShowDetails}
                                        widthHeader={'gridHLPure-digitalVaultCategoriesAdministration-col1Header'}
                                        styleCol1={'gridHLPure-digitalVaultCategoriesAdministration-cellItemStylesCol1'}
                                        styleCol3={'gridHLPure-digitalVaultCategoriesAdministration-cellItemStylesCol3'}
                                        styleCol4={'gridHLPure-digitalVaultCategoriesAdministration-cellItemStylesCol4'}
                                        widthHeaderCol4={'gridHLPure-digitalVaultCategoriesAdministration-cellItemStylesTh4'}
                                        headerColumnOneClass={'digitalVaultCategoriesAdministration-headerCol1'}
                                        headerColumnTwoClass={'digitalVaultCategoriesAdministration-headerCol2'}
                                        headerColumnFiveClass={'digitalVaultCategoriesAdministration-headerCol5'}
                                    // iconOneActive
                                    // labelOneActions={'Subcategorías'}
                                    // iconTwoActive
                                    // labelTwoActions={'Ver detalles'}
                                    // labelFourthActions={'Ver detalles'}
                                    />
                                </Grid>
                            </>}
                    </>
                }
            </Grid>
        </Container>

    );
}

export default DigitalVaultCategoriesAdministrationView